export default __webpack_public_path__ + "locales/si/FilesSettings.json?hash=8eabc674b4896df3855710eaa9b58c32";